/**
 * Configurazione ambiente di sviluppo
 */
export const environment = {
  production: false,  // gestisce il log

  // Per la gestione WhatsApp / API Laravel in sviluppo
  API_ENDPOINT: 'https://api.pnit.it/api',
  LINK_REGISTRAZIONE: 'https://app.pnit.it/signup/',

  // Titolo scheda browser (collaudo / sviluppo)
  PAGE_TITLE: 'COLLAUDO Auth Ameconviene.it Finance',
  LOGO_HEADER_LIGHT: 'logo_ameconviene_stile_chiaro_SVILUPPO.webp',
  LOGO_MOBILE_LIGHT: 'logo_ameconviene_stile_chiaro_MOBILE.webp',
  LOGO_HEADER_DARK: 'logo_ameconviene_stile_scuro_SVILUPPO.webp',
  LOGO_MOBILE_DARK: 'logo_ameconviene_stile_scuro_MOBILE.webp',
  ENABLE_DEBUG_ALERTS: false, // Temporaneamente abilitato per debug SSO loader
  ENABLE_CONSOLE_LOGS: false, // Debug SSO generate-ticket / prepareTicket
  //mostra il widget comunicazioni
  SHOW_WIDGET_COMUNICAZIONI: true,
  /** Se true, landing raggruppa i profili per app; se false, una card per profilo */
  RAGGRUPPA_PROFILI: false,
  /** Se true, landing mostra app-portale solo agli utenti con ruolo admin */
  NASCONDI_APP_PORTALE: false,
  /** Coordinamento tab Auth-App (chiusura/overlay disabilitati nel servizio). */
  AMCF_TAB_COORDINATOR_ENABLED: false,
  AMCF_TAB_RESOLVE_MS: 300,
};
